"use client";
import { ProsList } from "@components/ui/pros-list/ProsList";
import { Auth, CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { Text } from "@ecco/ui/text";
import { Button } from "@ecco/ui/button";
import type { BoxProps } from "@ecco/ui/box";
import { Box } from "@ecco/ui/box";
import { type FC } from "react";
import { useGlobalModalContext } from "@components/GlobalModalProvider/GlobalModalProvider";
import { ModalTypes } from "@lib/enums/ModalTypes";
import { RUM_ACTION_NAME } from "@lib/monitoring/rumActionNames";

const CreateAccountInvitation: FC<BoxProps> = ({ ...otherProps }) => {
    const { getMultiple } = useMicrocopy();
    const { showModal } = useGlobalModalContext();

    const handleCreateAccountClick = () => {
        showModal(ModalTypes.createAccount);
    };

    const microcopies = getMultiple(CommonCMS.page, [
        Auth.createAccountInvitation,
        CommonCMS.button.createAccount,
        ...CommonCMS.usps.userPanel,
    ]);

    return (
        <Box mt={[2, 2, 2, 0]} py={6} px={[3, 4, 4, 6]} bg="white" {...otherProps}>
            <Text
                fontSize={["mobileHeading3", "desktopHeading5"]}
                fontWeight={"semibold"}
                mb={6}
                textTransform="uppercase"
            >
                {microcopies[Auth.createAccountInvitation]}
            </Text>
            <ProsList
                usps={CommonCMS.usps.userPanel.map((key) => ({
                    key,
                    text: microcopies[key],
                }))}
            />
            <Button
                onClick={handleCreateAccountClick}
                variant={"solid"}
                textDecoration={"none"}
                mt={8}
                data-dd-action-name={RUM_ACTION_NAME.CREATE_ACCOUNT}
            >
                <span>{microcopies[CommonCMS.button.createAccount]}</span>
            </Button>
        </Box>
    );
};

export default CreateAccountInvitation;
